// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3zY_P","paginationActive":"Pagination_paginationActive__11k7O"};